// extracted by mini-css-extract-plugin
export default {"innerContainer":"deviceAccess_innerContainer__HKxAN","appCard":"deviceAccess_appCard__07HPW","left":"deviceAccess_left__1JFHn","right":"deviceAccess_right__-deU7"};